import styled from "styled-components"

const StyledContainer = styled.div<{
  $height: number[]
  $width: number[]
  $top: number[]
  $bottom: number[]
}>`
  position: fixed;
  /* why top + 60? */

  top: ${({ $top }) => ($top ? `${$top[0]}px` : "auto")};
  bottom: ${({ $bottom }) => ($bottom ? `${$bottom[0]}px` : "auto")};
  left: 50%;
  z-index: 99999;
  transform: translateX(-50%);
  height: fit-content;
  width: ${({ $width }) => $width[0]}px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 15px;
  pointer-events: none;
  ${(p) => p.theme.breakpoints.up("md")} {
    height: fit-content;
    width: ${({ $width }) => $width[1]}px;
    top: ${({ $top }) => ($top ? `${$top[1]}px` : "auto")};
    bottom: ${({ $bottom }) => ($bottom ? `${$bottom[1]}px` : "auto")};
  }
`

type ContainerProps = {
  children: React.ReactNode
  height: number[]
  width: number[]
  top?: number[]
  bottom?: number[]
}

function FloatingTextContainer({
  children,
  height,
  width,
  top,
  bottom,
}: ContainerProps) {
  return (
    <StyledContainer
      $height={height}
      $width={width}
      $top={top}
      $bottom={bottom}
    >
      {children}
    </StyledContainer>
  )
}

export default FloatingTextContainer
